import { render } from "./TagIconNew.vue?vue&type=template&id=9f08d98c"
import script from "./TagIconNew.vue?vue&type=script&lang=js"
export * from "./TagIconNew.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__